import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    message: String,
    reload: Boolean
  }

  connect() {
    // Defer the success toast to the destination page so it shows up *after* we
    // navigate back, rather than flashing on a page we're about to leave. The
    // toast controller picks this up on connect (see shared/toast_controller.js).
    if (this.messageValue) {
      sessionStorage.setItem('pendingToast', this.messageValue)

      // history.back() fires a restoration visit before the reload lands, so the
      // toast controller must wait for the reload rather than show it on the
      // about-to-be-replaced restoration snapshot.
      if (this.reloadValue) {
        sessionStorage.setItem('pendingToastAwaitReload', 'true')
      }
    }

    history.back()
    this.reloadData()
  }

  reloadData() {
    const waitTimeBeforeRefreshPage = 200 // wait for the back navigation before refreshing

    if (this.reloadValue) {
      setTimeout(() => {
        window.location.reload();
      }, waitTimeBeforeRefreshPage)
    }
  }
}
